import type { ILinkCard } from "./LinkCards.types";
import Card from "../Card/Card";
import { Link } from "react-router-dom";
import { useMemo } from "react";
interface Props extends ILinkCard {
  pathPrefix?: string | Array<string | undefined>;
}
const LinkCard = ({ pathPrefix, path, name, desc, onClick }: Props) => {
  const preparedPath = useMemo(() => {
    let parsedPath = "/";
    if (pathPrefix) {
      if (typeof pathPrefix === "string") {
        parsedPath += pathPrefix + "/";
      } else if (Array.isArray(pathPrefix)) {
        for (const part of pathPrefix) {
          if (part) parsedPath += part + "/";
        }
      }
    }
    if (path === "desktop-app") {
      parsedPath += "desktop-and-tablet-apps";
    } else {
      parsedPath += path;
    }
    return parsedPath;
  }, [path, pathPrefix]);

  const getCard = () => (
    <Card
      key={name}
      cardName={name.match(/Desktop App/i) ? "Desktop / Tablet App" : name}
      cardDetails={desc}
      onClick={onClick ?? (() => {})}
    />
  );

  return path ? (
    <Link
      key={preparedPath}
      to={preparedPath}
      style={{ textDecoration: "none" }}>
      {getCard()}
    </Link>
  ) : (
    getCard()
  );
};
export default LinkCard;
